import { useQuery } from '@tanstack/react-query';
import { getApiClient } from '../api/apiClient';

const apiClient = getApiClient('kisanVani');

/**
 * Fetches a single post by id. Used when a page is opened from a link
 * (e.g. a notification) and the post details were not passed along in router state.
 */
export function usePost(postId, { enabled = true } = {}) {
  return useQuery({
    queryKey: ['post', postId],
    queryFn: async () => {
      const response = await apiClient.get(`/posts/${postId}`);
      if (!response.data?.success || !response.data?.data) {
        throw new Error(response.data?.message || 'Post not found');
      }
      return response.data.data;
    },
    enabled: !!postId && enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
